import React from 'react'
import { connect } from 'react-redux'
import { changeCalendar } from '../actions'
import classnames from 'classnames';

const HomeCalendar = ({ calendar, selectedCalendar, changeCalendar }) => (
  calendar ?
    <div>
      <div className="tabs">
        <ul>
          {Object.keys(calendar).map(key => {
            return (
              <li 
                key={key}
                className={classnames({ 'is-active': selectedCalendar === key })}
                onClick={() => changeCalendar(key)}
              ><a>{key}</a></li>
            )
          })}
        </ul>
      </div>
      <div className="calendar">
        {Object.keys(calendar).map(key => {
          return (
            <div 
              key={key}
              dangerouslySetInnerHTML={{__html: calendar[key]}}
              className={classnames({ 'is-active': selectedCalendar === key })}
            ></div>
          )
        })}
      </div>
    </div>
  :
    <div>Loading...</div>
)

export default connect(
  state => ({
    calendar: state.home.calendar,
    selectedCalendar: state.home.selectedCalendar
  }),
  { changeCalendar }
)(HomeCalendar)



// WEBPACK FOOTER //
// ./src/components/HomeCalendar.js